'use strict';

var Constants = require('../../constants/constants');
var Utils = require('../../utils/utils');

var Carousel = function() {
  var self = this;

  self.config = {
    carousel: '.multimedia-hero__carousel',
    main: '.multimedia-hero__carousel-main',
    thumbnails: '.multimedia-hero__carousel-thumbs',
    MainSettings: function(asNavId) {
      this.asNavFor = asNavId;
      this.speed = 600;
      this.touchThreshold = 8;
      this.cssEase = 'cubic-bezier(0.165, 0.84, 0.44, 1)';
      this.prevArrow = '<button type="button" class="multimedia-hero__carousel-main-arrow -left"><span class="icon icon--carousel-prev--dark"></span></button>';
      this.nextArrow = '<button type="button" class="multimedia-hero__carousel-main-arrow -right"><span class="icon icon--carousel-next--dark"></span></button>';
    },
    ThumbnailsSettings: function(asNavId) {
      this.asNavFor = asNavId;
      this.focusOnSelect = true;
      this.speed = 800;
      this.cssEase = 'cubic-bezier(0.165, 0.84, 0.44, 1)';
      this.centerMode = true;
      this.arrows = false;
      this.swipe = false;
      this.slidesToShow = 3;
      this.mobileFirst = true;
      this.responsive = [
        {
          breakpoint: self.getBreakpointInt('TINY'),
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: self.getBreakpointInt('SMALL'),
          settings: {
            slidesToShow: 7
          }
        }
      ];
    }
  }

  self.getBreakpointInt = function(breakpointName) {
    var int = parseInt(new Constants().MEDIA_QUERIES[breakpointName].match(/\d+/)[0]);
    return int;
  }

  self.parseCarousels = function() {
    $(self.config.carousel).each(function() {
      var $this = $(this);
      var $main = $this.find(self.config.main);
      var $thumbnails = $this.find(self.config.thumbnails);
      self.setUniqueIds($main, $thumbnails);
    });
  }

  self.setUniqueIds = function($main, $thumbnails) {
    var token = new Utils().randomId();
    var mainId = 'artworkCarouselMain' + token;
    var thumbnailsId = 'artworkCarouselThumbnails' + token;
    $main.attr('id', mainId);
    $thumbnails.attr('id', thumbnailsId);
    self.initCarousels($main, $thumbnails, mainId, thumbnailsId);
  }

  self.initCarousels = function($main, $thumbnails, mainId, thumbnailsId) {
    var mainSettings = new self.config.MainSettings('#' + thumbnailsId);
    var thumbnailsSettings = new self.config.ThumbnailsSettings('#' + mainId);
    $main.slick(mainSettings);
    $thumbnails.slick(thumbnailsSettings);
  }

  self.init = function() {
    self.parseCarousels();
  }
};

module.exports = Carousel;
